exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".distribution-price-suffix[data-v-41e575f2]{height:100%;line-height:32px}", ""]);

// exports
